import { ReactElement } from 'react'
import { Button, Dialog } from '@equinor/eds-core-react'

export type InfoDialogType = 'Info' | 'Error'

interface Props {
    title?: string
    children: ReactElement
    onConfirmClick?: () => void
    type?: InfoDialogType
}

const InfoDialog = (props: Props) => {
    return (
        <Dialog
            open
            style={{
                maxWidth: '300px',
                width: '90vw',
            }}
        >
            <Dialog.Header>
                <Dialog.Title>{props.title}</Dialog.Title>
            </Dialog.Header>
            <Dialog.CustomContent>{props.children}</Dialog.CustomContent>
            <Dialog.Actions style={{ justifySelf: 'end' }}>
                <Button color={props.type === 'Error' ? 'danger' : 'primary'} onClick={() => props.onConfirmClick?.()}>
                    Close
                </Button>
            </Dialog.Actions>
        </Dialog>
    )
}

export default InfoDialog
